import Utils from './library/Utils.js';
import Preloader from './scenes/preloader/Preloader.js';
import Boot from './scenes/boot/Boot.js';
import Test from './scenes/Test.js';
import gameData, { GameMode, MaxBillCoinData } from './gameData.js';
import ABCyaLib from '@abcya/abcya_lib';
import gameInfo from '../assets/json/gameInfo.json';
import setupGameConfig from './GameConfig.js';

class Main
{
    constructor()
    {
        let config = {
            type: Phaser.WEBGL,
            width: 1024,
            height: 768,
            parent: 'contentWrapper',
            scale: {
                mode: Phaser.Scale.FIT,
                autoCenter: Phaser.Scale.CENTER_BOTH
            },
            canvas: document.getElementById('canvas'),
            scene: {
                preload: preload,
                pack: {
                    files: [
                        { type: 'scenePlugin', key: 'SpineWebGLPlugin', url: 'plugins/SpineWebGLPlugin.js' }
                    ]
                }
            },
            physics: {
                default: 'matter',
                matter: {
                    gravity: {
                        y: 0
                    },
                    debug: false,
                    debugBodyColor: 0xff0000
                }
            }
        };

        this.game = new Phaser.Game(config);
        this.game.isMuted = false;

        this.game.scene.add('Test', new Test());
        this.game.scene.add('Boot', new Boot());
        this.game.scene.add('Preloader', new Preloader());

        let scenes = gameData.scenes;
        for (let i = 0; i < scenes.length; i++)
        {
            this.game.scene.add(scenes[i].name, new scenes[i].class());
        }

        this.game.scene.start('Boot');

        Utils.Initialize(this.game);
    }
}

function preload()
{
    this.load.setPath('assets/spine/');
    gameData.spines.forEach((spine) =>
    {
        this.load.spine(spine, spine + '.json', spine + '.atlas');
    });
}

(async function handshake()
{
    try
    {
        await ABCyaLib.Environment.instance.doParentHandshake();
    } catch (error)
    {
        console.warn(error);
    }

    const gameType = ABCyaLib.getConfig()?.gameType ?? gameData.gameType;
    switch (gameType)
    {
        case "0": // sorting
            gameData.gameType = 0;
            break;
        case "1": // counting
            gameData.gameType = 1;
            break;
    }


    console.info("ABCya Game Info:", gameInfo);

    ABCyaLib.Environment.instance.setupGameConfig(setupGameConfig);

    // set the config into the game data
    const config = ABCyaLib.Environment.instance.gameConfig;
    if(config.restrictions != null){
      MaxBillCoinData.maxBills = config.restrictions.maxBills;
      MaxBillCoinData.maxCoins = config.restrictions.maxCoins;
      MaxBillCoinData.maxValue = config.restrictions.maxValue;
      MaxBillCoinData[GameMode.Pennies] = config.restrictions.maxPennies;
      MaxBillCoinData[GameMode.Nickels] = config.restrictions.maxNickels;
      MaxBillCoinData[GameMode.Dimes] = config.restrictions.maxDimes;
      MaxBillCoinData[GameMode.Quarters] = config.restrictions.maxQuarters;
      MaxBillCoinData[GameMode.Ones] = config.restrictions.maxOnes;
      MaxBillCoinData[GameMode.Fives] = config.restrictions.maxFives;
      MaxBillCoinData[GameMode.Tens] = config.restrictions.maxTens;
      MaxBillCoinData[GameMode.Twenties] = config.restrictions.maxTwenties;
  }

    var main = new Main();
})();